import { i18n } from '@fs/zion-locale'

export function getGender(gender) {
  if (gender === 'http://gedcomx.org/Male') {
    gender = 'male'
  } else if (gender === 'http://gedcomx.org/Female') {
    gender = 'female'
  }
  return gender
}

export const newAncestorTemplate = (year, person, region, language, header, additionalText) => {
  return {
    id: 39,
    icon: '',
    image: '',
    type: 'ancestorDetails',
    title: i18n.t('aam.content.about-your-ancestor', 'About your ancestor'),
    header,
    year,
    person,
    region,
    language,
    additionalText,
  }
}
